import React, { useState } from "react";
import { connect } from "react-redux";
import Maincontent from "./Maincontent";
import AbsentReport from "./absentReport";

import { Layout, Breadcrumb } from "antd";
const { Content } = Layout;

const UserRole = () => {
  const [updatelist, setUpdatelist] = useState(true);

  return (
    <>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>New Absent Report</Breadcrumb.Item>
        {/* <Breadcrumb.Item>All</Breadcrumb.Item> */}
      </Breadcrumb>
      {/* <Maincontent /> */}
      <AbsentReport />
    </>
  );
};

export default connect()(UserRole);
